import { useEffect, useState } from 'react';
import { useCalls } from '../context/calls-context.jsx';
import { callsRequest } from './calls-api.js';
import { callsList } from '../dto/calls.dto.js';
import { buildCallsQuery } from '../model/calls.model.js';

export function useCallsList(view, filters) {
  const { token, canView, revision } = useCalls();
  const query = buildCallsQuery(filters);
  const scope = `${token}:${view}:${query}:${revision}:${canView}`;
  const [state, setState] = useState({ scope, items: [], total: 0, loading: true, error: '' });
  useEffect(() => {
    let live = true;
    setState({ scope, items: [], total: 0, loading: canView, error: '' });
    if (canView) callsRequest(token, `/${view === 'plan' ? 'tasks' : 'attempts'}?${query}`).then((payload) => {
      if (live) setState({ scope, ...callsList(payload), loading: false, error: '' });
    }).catch(() => {
      if (live) setState({ scope, items: [], total: 0, loading: false, error: 'calls.loadError' });
    });
    return () => { live = false; };
  }, [scope, token, canView, query, view]);
  return state.scope === scope ? state : { items: [], total: 0, loading: canView, error: '' };
}
